import request from '@/utils/request'

const baseUrl = process.env.VUE_APP_PURCHASE_API

// 分页查询采购方案列表
export function getPurchasePlanListApi(params) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-plans/page`,
    method: 'get',
    params
  })
}

// 删除已保存的项目
export function deletePurchasePlanApi(planId) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-plans/${planId}`,
    method: 'delete'
  })
}

// 发起寻源 -- 询比价
export function initiateSourcingByPlanApi(planId) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-plans/${planId}/souring`,
    method: 'post'
  })
}

// 查询方案详情
export function getPurchasePlanDetailApi(planId) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-plans/${planId}/detail`,
    method: 'get'
  })
}

// 查询可挑选的品目列表
export function getPurchaseApplyMaterialListApi(params) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-requirements/task-items/page`,
    method: 'get',
    params
  })
}

// 查询可选择的框架协议
export function getFrameAgreementListForSelectApi(params) {
  return request({
    url: `${baseUrl}/workbench/price-agreements/item-relations/page`,
    method: 'get',
    params
  })
}

// 保存方案 （新增）
export function addStorePurchasePlanApi(data) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-plans`,
    method: 'post',
    data
  })
}

// 保存方案 （编辑）
export function editStorePurchasePlanApi(data) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-plans/${data.planId}`,
    method: 'put',
    data
  })
}

// 发布方案（新增）
export function addPublishPurchasePlanApi(data) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-plans/apply`,
    method: 'post',
    data
  })
}

// 发布方案（编辑）
export function editPublishPurchasePlanApi(data) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-plans/${data.planId}/apply`,
    method: 'put',
    data
  })
}

// 分配执行人
export function purchaseApplyAssignExecutorApi(data) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-requirements/task-items/assign`,
    method: 'post',
    data
  })
}

// 采购方案 --- 发起审批（待提交审批状态时）
export function initiatePurchasePlanApprovalApi(planId) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-plans/${planId}/apply-flows/start`,
    method: 'put'
  })
}

// 采购方案 - 分配采购,科目，交货地点，部门，作废
export function setBatchPlanItem(data) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-plans/batchPlanItem`,
    method: 'post',
    data
  })
}

// 采购任务-编辑品目单（保存）
export function setEditTaskItem(data) {
  const { itemId, ...other } = data
  return request({
    url: `${baseUrl}/workbench/demander/purchase-requirements/task-items/${itemId}`,
    method: 'put',
    data: other
  })
}

// 采购任务-分配执行人,科目，交货地点，部门，作废
export function setTaskItemAssign(data) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-requirements/task-items/assign`,
    method: 'post',
    data
  })
}
